import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import {useTheme} from "@mui/material/styles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {Box, Button, Grid, Typography} from "@mui/material";
import {TableCustom} from "../../../../components/common";
import InventoryGroupChildrenModal from "./InventoryGroupChildrenModal";

const InventoryGroupChildren = ({methods, policies, items, soloVer }) => {
  const [t] = useTranslation();
  const { getValues, setValue, control, watch} = methods;
  const [indexGroupChildrenHostEdit, setIndexGroupChildrenHostEdit] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    modalChildrenGroupName: '',
    modalChildrenGroupDescription: '',
    modalTags: [],
    modalChildrenGroupHosts: []
  });
  const theme = useTheme();

  const watchHostField = watch(policies.hostGroups.name, []);

  const onSubmitCreate = (data) => {
    const childrens = [...getValues(policies.childrenGroups.name), data];
    setValue(policies.childrenGroups.name, childrens);
    handleCloseModal();
  };

  const onSubmitEdit = (data) => {
    const childrens = getValues(policies.childrenGroups.name).map((h,i) => {
      if (i === data.index) {
        return {
          name: data.name,
          description: data.description,
          tags: data.tags,
          hostGroups: data.hostGroups,
          groupsToShow: data.hostGroups.map(host => host.label).join(',')
        }
      } else return h
    });
    setValue(policies.hostGroups.name, childrens);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAdd = (data) => {
    setDefaultValues({
      modalChildrenGroupName: '',
      modalChildrenGroupDescription: '',
      modalTags: [],
      modalChildrenGroupHosts: []
    });
    setIsEdit(false);
    setOpenModal(true);
  };

  const handleDelete = (item) => {
    const items = getValues(policies.childrenGroups.name);
    setValue(
      policies.childrenGroups.name,
      items.filter(i => i.name !== item.name)
    );
  };

  const handleEdit = (item) => {
    setDefaultValues({
      modalChildrenGroupName: item.name,
      modalChildrenGroupDescription: item.description,
      modalTags: item.tags,
      modalChildrenGroupHosts: item.hostGroups,
    });

    const items = getValues(policies.childrenGroups.name);
    const index = items.findIndex(h => h.name === item.name);
    setIndexGroupChildrenHostEdit(index);
    setIsEdit(true);
    setOpenModal(true);
  };

  const columns = [
    { label: t('inventoryList.childrenGroupHost.table.columns.name'), key: 'name' },
    { label: t('inventoryList.childrenGroupHost.table.columns.groups'), key: 'groupsToShow' },
  ];

  const actions = [
    {
      label: t('inventoryList.childrenGroupHost.table.actions.edit'),
      icon: <EditOutlinedIcon color='primary'/>,
      handle: handleEdit
    },
    {
      label: t('inventoryList.childrenGroupHost.table.actions.delete'),
      icon: <HighlightOffIcon color='primary'/>,
      handle: handleDelete
    }
  ];

  return (
    <>
      <Box sx={{ overflow: 'hidden' }}>
        <Grid container spacing={2} alignItems="center" sx={{ pt: 1 }}>
          <Grid item xs={12} sm={4} md={4} lg={4} sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3
          }}>
            <Typography variant="h6" sx={{ padding: '4px 0px' }}>
              {t('inventoryList.childrenGroupHost.title')}
            </Typography>
            {!soloVer?<Button variant="contained" onClick={handleAdd} type="button" disabled={!watchHostField.length} >
              {t('inventoryList.childrenGroupHost.button')}
            </Button>:null}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box
              sx={{
                border: `1px solid ${theme.palette.grey[400]}`,
                borderRadius: 1,
                overflow: 'hidden',
              }}
            >
              <Controller
                control={control}
                name={policies.childrenGroups.name}
                id={policies.childrenGroups.id}
                render={({ field: { value } }) => (
                  <TableCustom
                    columns={columns}
                    content={value}
                    actions={actions}
                    config={{
                      notResults: {
                        title: 'inventoryList.hosts.table.title',
                        description: 'inventoryList.hosts.table.description',
                        disabledIcon: true,
                        size: '20vh'
                      }
                    }}
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      { openModal &&
        <InventoryGroupChildrenModal
          open={openModal}
          handleClose={handleCloseModal}
          onSubmitCreate={onSubmitCreate}
          onSubmitEdit={onSubmitEdit}
          defaultValues={defaultValues}
          isEdit={isEdit}
          policies={policies}
          items={getValues(policies.childrenGroups.name)}
          currentGroups={getValues(policies.hostGroups.name).map(i => ({value: i.name, label: i.name}))}
          index={indexGroupChildrenHostEdit}
        />
      }
    </>
  );

}

export default InventoryGroupChildren;